<section class="patient-appointments">
  <div class="patient-appointments__filters">
    <label>
      {{ 'PATIENT_SPACE.APPOINTMENTS.FILTER' | translate }}
      <select [(ngModel)]="state" (ngModelChange)="load()">
        <option value="upcoming">{{ 'PATIENT_SPACE.APPOINTMENTS.STATES.UPCOMING' | translate }}</option>
        <option value="pending">{{ 'PATIENT_SPACE.APPOINTMENTS.STATES.PENDING' | translate }}</option>
        <option value="past">{{ 'PATIENT_SPACE.APPOINTMENTS.STATES.PAST' | translate }}</option>
      </select>
    </label>
  </div>

  @if (loading) {
    <p>{{ 'COMMON.LOADING' | translate }}</p>
  } @else if (!rows.length) {
    <div class="patient-appointments__empty">{{ 'PATIENT_SPACE.APPOINTMENTS.EMPTY' | translate }}</div>
  } @else {
    <article
      class="patient-appointments__row"
      [class.is-focused]="isFocused(row)"
      [attr.id]="'patient-appointment-' + row?.id"
      *ngFor="let row of rows"
    >
      <div class="patient-appointments__main">
        <strong>{{ row?.site?.name || '-' }}</strong>
        <p>{{ row?.start | date: 'dd/MM/yyyy HH:mm' }} - {{ row?.end | date: 'HH:mm' }}</p>
        <small>{{ row?.treatments?.join(', ') || row?.description || '-' }}</small>
        @if (row?.counter_proposal?.status === 'PENDING') {
          <p class="patient-appointments__proposal">
            {{ row?.counter_proposal?.start | date: 'dd/MM/yyyy HH:mm' }} - {{ row?.counter_proposal?.end | date: 'HH:mm' }}
          </p>
          @if (row?.counter_proposal?.comment) {
            <small>{{ row?.counter_proposal?.comment }}</small>
          }
        }
        @if (proposalHint(row); as hint) {
          <div class="patient-appointments__hint">{{ hint }}</div>
        }
      </div>
      <div class="patient-appointments__meta">
        <span class="patient-appointments__state" [ngClass]="appointmentStateClass(row)">
          {{ appointmentStateLabel(row) }}
        </span>
        @if (row?.counter_proposal?.status === 'PENDING' || canCancelPending(row)) {
          <div class="patient-appointments__actions">
            @if (row?.counter_proposal?.status === 'PENDING') {
              <button type="button" [disabled]="savingId === row?.id" (click)="acceptProposal(row)">
                {{ 'PATIENT_SPACE.APPOINTMENTS.ACCEPT_PROPOSAL' | translate }}
              </button>
              <button type="button" class="is-secondary" [disabled]="savingId === row?.id" (click)="declineProposal(row)">
                {{ 'PATIENT_SPACE.APPOINTMENTS.DECLINE_PROPOSAL' | translate }}
              </button>
              <button type="button" class="is-ghost" [disabled]="savingId === row?.id" (click)="selectAnother(row)">
                {{ 'PATIENT_SPACE.APPOINTMENTS.SELECT_ANOTHER' | translate }}
              </button>
            }
            @if (canCancelPending(row)) {
              <button type="button" class="is-danger" [disabled]="savingId === row?.id" (click)="cancelPendingRequest(row)">
                {{ 'PATIENT_SPACE.APPOINTMENTS.CANCEL_PENDING' | translate }}
              </button>
            }
          </div>
        }
      </div>
    </article>
  }
</section>
